var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":_vm.viewBox,"width":_vm.width,"height":_vm.height,"fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_vm._t("default",null,{"strokeClass":_vm.strokeClass,"fillClass":_vm.fillClass})],2)}
var staticRenderFns = []

export { render, staticRenderFns }